import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.juju');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-juju',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.juju/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraJujuComponent implements OnInit, OnDestroy {
    public loading: boolean = false;
    public error: string = '';
    public timestamp: string = '';
    public tab: string = 'overview';
    public readonly commandExample: string = [
        'juju status --format=json',
        'juju machines',
        'juju show-unit <application>/<unit>',
        'juju debug-log --replay --include machine-0',
    ].join('\n');
    public cards: any[] = [];
    public configItems: any[] = [];
    public liveCards: any[] = [];
    public registrations: any[] = [];
    public emptyMessage: string = '';
    public live: any = { status: 'disabled', message: '', applications: [] };
    private langSub?: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        this.langSub = this.translate.onLangChange.subscribe(async () => {
            await this.refresh();
        });
        await this.refresh();
    }

    public ngOnDestroy() {
        if (this.langSub) this.langSub.unsubscribe();
    }

    public async refresh() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        const response = await wiz.call('load');
        this.loading = false;

        if (response.code === 200) {
            const payload = this.localizeData(response.data || {});
            this.timestamp = payload.timestamp || '';
            this.cards = payload.cards || [];
            this.configItems = payload.config_items || [];
            this.liveCards = payload.live_cards || [];
            this.registrations = payload.registrations || [];
            this.emptyMessage = payload.empty_message || '';
            this.live = payload.live || { status: 'disabled', message: '', applications: [] };
        } else {
            this.error = this.translate.instant('page.juju.error_load');
        }

        await this.service.render();
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public lastUpdatedText(): string {
        if (!this.timestamp) return '';
        return this.translate.instant('page.juju.last_updated', { timestamp: this.timestamp });
    }

    public badgeClass(tone: string): string {
        if (tone === 'emerald') return 'bg-emerald-50 text-emerald-700';
        if (tone === 'amber') return 'bg-amber-50 text-amber-700';
        if (tone === 'rose') return 'bg-rose-50 text-rose-700';
        if (tone === 'sky') return 'bg-sky-50 text-sky-700';
        return 'bg-zinc-100 text-zinc-700';
    }

    public cardClass(tone: string): string {
        if (tone === 'emerald') return 'border-emerald-200';
        if (tone === 'amber') return 'border-amber-200';
        if (tone === 'rose') return 'border-rose-200';
        if (tone === 'sky') return 'border-sky-200';
        return 'border-zinc-200';
    }

    public iconClass(tone: string, icon: string): string {
        const color = tone === 'emerald'
            ? 'text-emerald-600'
            : tone === 'amber'
                ? 'text-amber-600'
                : tone === 'rose'
                    ? 'text-rose-600'
                    : tone === 'sky'
                        ? 'text-sky-600'
                        : 'text-zinc-500';
        return `${icon} ${color}`;
    }

    private isEnglishLanguage() {
        return String(this.translate.currentLang || this.translate.getDefaultLang() || 'ko').toLowerCase().startsWith('en');
    }

    private localizeText(value: string) {
        if (!this.isEnglishLanguage()) return value;

        const replacements: Array<[string, string]> = [
            ['로컬 Juju 등록 기록이 없습니다. Juju가 비활성 상태이거나 아직 deploy 완료 후 등록이 발생하지 않은 상태입니다.', 'No local Juju registration history is available. Juju may be disabled or no registration has been recorded after deploy yet.'],
            ['Juju는 활성화되어 있지만 아직 data/juju_state.json에 등록 이력이 없습니다.', 'Juju is enabled but there is still no registration history in data/juju_state.json.'],
            ['RELAYENV_ENABLE_JUJU 기준', 'Based on RELAYENV_ENABLE_JUJU'],
            ['등록 진행중', 'Registering'],
            ['등록 실패', 'Registration Failed'],
            ['해제 실패', 'Release Failed'],
            ['등록됨', 'Registered'],
            ['미설정', 'Not configured'],
            ['자동 판별', 'Auto-detect'],
            ['미확인', 'Unknown'],
            ['비활성', 'Disabled'],
            ['점검중', 'Maintenance'],
            ['대기중', 'Pending'],
            ['실행중', 'Running'],
            ['시작됨', 'Started'],
            ['중단', 'Down'],
            ['차단', 'Blocked'],
            ['대기', 'Idle'],
            ['실패', 'Failed'],
            ['주의', 'Warning'],
            ['정상', 'Healthy'],
        ];

        let text = String(value ?? '');
        for (const [source, target] of replacements) {
            text = text.split(source).join(target);
        }
        return text;
    }

    private localizeData(value: any): any {
        if (typeof value === 'string') return this.localizeText(value);
        if (Array.isArray(value)) return value.map((item) => this.localizeData(item));
        if (value && typeof value === 'object') {
            return Object.keys(value).reduce((result: any, key: string) => {
                result[key] = this.localizeData(value[key]);
                return result;
            }, {});
        }
        return value;
    }
}
export default PageKieraJujuComponent;
